import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '「UI改善にシステム改修が伴うと、PDCAが回せない」その課題をAitria（アイトリア）の自社プロダクトflamingoで解決。ヒューリスティック評価とABテストを組み合わせた継続的なUI改善で、セブンネットショッピングのCVRを107%改善した事例です。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/7net/ogp_7net.png'

export const sevenNetPageMeta: PageMeta = {
  title: 'セブンネットショッピング CVR107%改善｜システム改修なしのEC UI改善事例 | Aitria（アイトリア）',
  description,
  keyword: 'UX/UI サイト分析 デザインリニューアル CVR改善 カスタマージャーニー',
  image: ogpImg,
  url: `${SITE_URL}/cases/7net/`,
}

export const sevenNetSchema = buildCaseStudySchema({
  slug: '7net',
  pageTitle: sevenNetPageMeta.title,
  description: sevenNetPageMeta.description,
  headline: 'CVR107%改善 - システム改修なしでECサイトのUX/UIを最新化',
  alternativeHeadline: '株式会社セブンネットショッピング',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/sevennet/top.png'],
  clientName: '株式会社セブンネットショッピング',
  breadcrumbLabel: 'CVR107%改善 - システム改修なしでECサイトのUX/UIを最新化',
})
